function fn_part_ui_video() {
    var fn = ".part_ui_video",
        yt = '.elm_youtube';

    if ($(fn).length) {
        $(fn).each(function(){
            var $yt = $(this).find(yt);
            if ($yt.length && $yt.attr("data-src").indexOf("autoplay=1") !== -1) {
                $(this).addClass("mod--active").find(".elm_overlay").fadeOut(300);
                $yt.html('<iframe src="'+ $yt.attr("data-src") + '" frameborder="0" allowfullscreen></iframe>');
            }
        });

        $(document).on("click", fn, function () {
            var $elm = $(this),
                $yt = $elm.find(yt),
                $video = $elm.find("video");
            if (!$elm.hasClass("mod--active")){
                if ($yt.length) {
                    var $src = $yt.attr("data-src");
                    if ($yt.attr("data-src").indexOf("autoplay") == -1) {
                        $yt.html('<iframe src="'+ $src + '&autoplay=1" frameborder="0" allowfullscreen></iframe>');
                    } else {
                        $yt.html('<iframe src="'+ $src.replace('autoplay=0','autoplay=1') + '" frameborder="0" allowfullscreen></iframe>');
                    }
                } else if ($video.length) {
                    $video[0].play();
                }
                setTimeout(function(){
                    $elm.addClass("mod--active").find(".elm_overlay").fadeOut(300);
                },100);
            } else if ($video.length) {
                $video[0].pause();
                $elm.removeClass("mod--active").find(".elm_overlay").fadeIn(300);
            }
        });
    }
}